var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentLayout", {
    attrs: {
      title: _vm.$t("label_essweb_eventType_list_title"),
      pad: "0",
      addBtn: _vm.hasBtn("add-admin-event-type"),
    },
    on: { new: _vm.toNew },
    scopedSlots: _vm._u([
      {
        key: "page-main",
        fn: function () {
          return [
            _c("Tabler", {
              attrs: {
                headers: _vm.headers,
                items: _vm.desserts,
                height: _vm.$vuetify.breakpoint.height - 275,
                showSelect: _vm.showSelect,
                totalCount: _vm.totalCount,
              },
              on: {
                change: function (page, perpage, callback) {
                  _vm.getList(page, perpage, callback)
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "item.color",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c(
                        "div",
                        { staticStyle: { "max-width": "20px" } },
                        [
                          _c("svg-icon", {
                            attrs: {
                              size: "24",
                              fill: item.color_code,
                              iconClass: "LabeledColour",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                },
                {
                  key: "item.name",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c("div", { staticClass: "text--primary table-title" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$getCommonLangValue(item.event_type_name)
                            ) +
                            " "
                        ),
                      ]),
                      _c(
                        "div",
                        { staticClass: "table-subtitle text--secondary" },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$getCommonLangValue(
                                  item.event_type_description
                                )
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ]
                  },
                },
                {
                  key: "item.abbr",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _vm._v(
                        _vm._s(_vm.$getCommonLangValue(item.event_type_abbr))
                      ),
                    ]
                  },
                },
                {
                  key: "item.action",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c("tableListTools", {
                        attrs: {
                          uuid: item.uuid,
                          delBtn: _vm.hasBtn("delete-admin-event-type"),
                          viewBtn: _vm.hasBtn("view-admin-event-type"),
                          editBtn: _vm.hasBtn("edit-admin-event-type"),
                          title: _vm.$t("label_essweb_eventType_list_title"),
                        },
                        on: {
                          delete: _vm.toDelete,
                          edit: _vm.toEdit,
                          view: _vm.toEdit,
                        },
                      }),
                    ]
                  },
                },
              ]),
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "tools-main",
        fn: function () {
          return undefined
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }